import React, { useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import instance from '../api/login/configAxios';
import { useDispatch } from 'react-redux';
import { setUserPermissions } from '../store/slices/meSlice';

// userType это тип (1 - сотрудник(Права только у сотрудников(Permisitions)), 2 - клиент, 3 - перевозчик)

const RequireAuth = ({ children, userType, link }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	let { clientId } = useParams();
	const { terminalId } = useParams();
	let { orderId } = useParams();
	let { actId } = useParams();
	let { reportId } = useParams();
	let { confirmed } = useParams();

	const [auth, setAuth] = useState(!!Cookies.get('csrftoken'));
	const [user, setUser] = useState({
		userType: Cookies.get('userType'),
		permissions: [],
	});

	const privateRoute = (userType = user.userType) => {
		const allowedRoutesForClient = ['/accountClient/main', '/accountClient/summary'];
		const allowedRoutesForEmployee = [
			'/accountEmpl/main',
			'/accountEmpl/summary',

			'/accountEmpl/clients',
			`/accountEmpl/clients/${clientId}`,
			'/accountEmpl/empls',
			'/accountEmpl/cars',
			'/accountEmpl/transporters',
			'/accountEmpl/terminals',

			'/accountEmpl/orders',
			`/accountEmpl/orders/${terminalId}/${orderId}`,
			'/accountEmpl/createImportOrder',
			'/accountEmpl/createExportOrder',
			'/accountEmpl/createTerminal',
			'/accountEmpl/createJob',

			'/accountEmpl/tableEntries',
			'/accountEmpl/containerAcceptance',
			`/accountEmpl/receptionTransmission/${confirmed}`,
			`/accountEmpl/receptionTransmission/act/${actId}`,
			`/accountEmpl/containerAcceptance/${reportId}`,
		];
		if (userType === '1') {
			return allowedRoutesForEmployee;
		} else if (userType === '2') {
			return allowedRoutesForClient;
		}
	};

	const allowedRoutes = privateRoute();

	useEffect(() => {
		const fetchData = async () => {
			try {
				const csrfToken = Cookies.get('csrftoken');
				if (csrfToken) {
					const response = await instance.get('/me/', {
						withCredentials: true,
						headers: {
							'X-CSRFToken': csrfToken,
						},
					});
					if (response.data) {
						// const newPermissions = response.data.permissions;
						// setUser((prev) => ({
						// 	...prev,
						// 	permissions: [...prev.permissions, ...newPermissions],
						// }));
						dispatch(setUserPermissions(response.data));
					}
				} else {
					setAuth(false);
				}
			} catch (error) {
				if (error.response.status === 401) {
					setAuth(false);
				}
			}
		};
		fetchData();
	}, []);

	if (!auth) {
		return <Navigate to={`${link}`} />;
	}
	if (auth && String(userType) === '1') {
		if (allowedRoutes?.includes(location.pathname)) {
			return React.cloneElement(children, {
				userPermissions: user.permissions,
			});
		} else {
			return <Navigate to={`${link}`} />;
		}
	} else if (auth && String(userType) === '2') {
		if (allowedRoutes.includes(location.pathname)) {
			return children;
		} else {
			return <Navigate to={`${link}`} />;
		}
	}
};

export default RequireAuth;
